package com.sddamico.draftmachine.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.data.PickOrigin
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmType
import com.sddamico.draftmachine.ds.displayBlock
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

/**
 * The mono micro-label stamped on a reassigned (TRADED) or inserted (COMPENSATORY) pick row in
 * the custom order editor.
 *
 * @param originTeamName the pick's original owner, shown for a TRADED pick.
 */
@Composable
fun PickOriginStamp(origin: PickOrigin, originTeamName: String? = null) {
  when (origin) {
    PickOrigin.COMPENSATORY -> SpanText(
      "COMPENSATORY · ADDED BY LM",
      Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.verde300).displayBlock(),
    )
    PickOrigin.TRADED -> SpanText(
      "↔ VIA ${originTeamName?.uppercase() ?: "—"}",
      Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.patina300).displayBlock(),
    )
  }
}
